import React, { useEffect } from 'react';
import { Cancel } from "@mui/icons-material";
import { SnackbarStyled } from "./styles";
import { IconButton } from "@mui/material";
import { useError } from './ErrorContext'; 

export default function SnackbarError() {
  const { message, type = 'error', clear } = useError(); 
  const isOpen = Boolean(message); 

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        clear();
      }, 6000);

      return () => clearTimeout(timer); 
    }
  }, [isOpen, clear]);

  const handleClose = () => {
    clear(); 
  };

  return (
    <SnackbarStyled
      open={isOpen}
      autoHideDuration={6000} 
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={handleClose}
      message={message} 
      type={type}
      action={
        <IconButton aria-label="closeError" sx={{ color: 'white' }} onClick={handleClose}>
          <Cancel />
        </IconButton>
      }
    >
    </SnackbarStyled>
  );
}
